import { TicketUpgradeFormPropsType } from "./type";
import React from "react";
import { useInitiateTicketChange } from "../../dataloader";
import { useParticipantDetails } from "../../../../context/participantDetails";
import { ApiRegRequest } from "../../../../../console/modules/registration/approval/details/types";
import { useCommonFeatures } from "../../../../../../context/commonFeatures";
import { useCopies } from "../../../../../../shared/hooks/useCopies";
import { getApplicableAmount } from "../util";

export default function useTicketUpgradeFormService({ onSuccessHandler, ...props }: TicketUpgradeFormPropsType) {
  const formRef = React.useRef<any>();
  const copies = useCopies();
  const { initConfirmationAlert } = useCommonFeatures();
  const { participantDetails } = useParticipantDetails();
  const { mutateAsync: initiateTicketChange } = useInitiateTicketChange(
    participantDetails?.registrationParticipantId,
    props.regParticipantFormDetails.registrationForm.id
  );

  const applicableAmount = React.useMemo(() => {
    return getApplicableAmount({
      applicablePrice: props.applicablePrice,
      ticketUpgradeFormDetails: props.ticketUpgradeDetails,
      regParticipantFormDetails: props.regParticipantFormDetails
    });
  }, [props.ticketUpgradeDetails, props.applicablePrice, props.regParticipantFormDetails]);

  const initTicketUpgrade = React.useCallback(
    async formValues => {
      try {
        const apiReqObj: ApiRegRequest = {
          registrationParticipantId: participantDetails?.registrationParticipantId,
          registrationFormId: props.regParticipantFormDetails.registrationForm.id,
          couponCode: props.appliedCouponCode,
          ...formValues
        };
        const data = await initiateTicketChange(apiReqObj);
        onSuccessHandler?.(data);
      } catch (e) {}
    },
    [
      participantDetails?.registrationParticipantId,
      props.regParticipantFormDetails.registrationForm.id,
      props.appliedCouponCode,
      initiateTicketChange,
      onSuccessHandler
    ]
  );

  const submitHandler = React.useCallback(
    async formValues => {
      if (applicableAmount?.value === 0) {
        initConfirmationAlert({
          message: copies.get("ticket.upgrade.confirmation.message"),
          handleConfirm: () => {
            initTicketUpgrade(formValues);
          }
        });
      } else {
        initTicketUpgrade(formValues);
      }
    },
    [initConfirmationAlert, initTicketUpgrade, copies, applicableAmount?.value]
  );

  return { formRef, submitHandler };
}
